import { render } from "./Banner.vue?vue&type=template&id=b0b2c28a"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
script.render = render

export default script